import { useCallback } from "react";
import { useNavigate } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";

import { analytics } from "@/lib/analytics";
import { auth } from "@/lib/looseend/store";
import { clearGuestHandoff } from "./guest/guestHandoff";
import { signOutApplicationSession } from "./session";

/**
 * Revokes the application session and clears cached/protected state.
 *
 * Guest-first access: sign-out returns to the PUBLIC guest Chat, not to a
 * login wall. The app shell establishes a fresh guest identity; the account's
 * conversations stay bound to the account and are never visible to that guest.
 */
export function useSignOut() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.cancelQueries();
    queryClient.clear();
    clearGuestHandoff();
    await signOutApplicationSession();
    auth.clearUser();
    analytics.reset();
    void navigate({ to: "/app", replace: true });
  }, [navigate, queryClient]);
}
